import Vue from 'vue'
import i18n from './locales/index'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'
import './plugins/ie'
import './plugins/custom/'
import App from './App.vue'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsmobile from './aws-exports'
import moment from 'moment'

// override configure to add additional settings
Amplify.configure({
  'aws_project_region': awsmobile.aws_project_region,
  'aws_cognito_identity_pool_id': awsmobile.aws_cognito_identity_pool_id,
  'aws_cognito_region': awsmobile.aws_cognito_region,
  'aws_user_pools_id': awsmobile.aws_user_pools_id,
  'aws_user_pools_web_client_id': awsmobile.aws_user_pools_web_client_id,
  'oauth': {},
  'aws_appsync_graphqlEndpoint': awsmobile.aws_appsync_graphqlEndpoint,
  'aws_appsync_region': awsmobile.aws_appsync_region,
  'aws_appsync_authenticationType': awsmobile.aws_appsync_authenticationType,
  'graphql_headers': async () => {
    return { Authorization: (await AmplifyModules.Auth.currentSession()).getIdToken().getJwtToken() }
  },
  'aws_cloud_logic_custom': [
    {
      'name': 'adwords-rest-api-dev',
      'endpoint': 'https://ln5dni9bdc.execute-api.eu-central-1.amazonaws.com',
      'region': 'eu-central-1',
    },
    {
      'name': 'adwords-rest-api-prod',
      'endpoint': 'https://41rs6qp883.execute-api.eu-central-1.amazonaws.com',
      'region': 'eu-central-1',
    },
  ],
})

Vue.use(AmplifyPlugin, AmplifyModules)

// environment
if (window.location.hostname === 'tools.omsag.de') {
  Vue.prototype.$env = 'prod'
} else {
  Vue.prototype.$env = 'dev'
}

// Vue.http.interceptors.push((request, next) => {
//   next(response => {
//     console.log('next')
//     console.log('response: ' + response.status)
//     if (response.status === 400 || response.status === 401 || response.status === 403) {
//       store.commit('auth/logout')
//       router.push({ path: '/login' })
//     }
//   })
// })

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY hh:mm')
  }
})

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
